<template>
  <div id="app">
    <Form />
    <TotalBalance />
    <BudgetList />
  </div>
</template>

<script>
import BudgetList from '@/components/BudgetList'
import TotalBalance from '@/components/TotalBalance'
import Form from '@/components/Form'
export default {
  name: 'App',
  components: {
    BudgetList,
    TotalBalance,
    Form,
  }, 
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
